import React, { useEffect } from "react";
import useAxios from "../../../../hooks/useAxios";
import UserWalletWithdrawReportsComponent from "../../../../components/private/user/userWallet/userWalletWithdrawReportsComponent";

function UserWalletWithdrawReportsContainer() {
  const { run, isLoading, error, data } = useAxios({});
  // useEffect(() => {
  //   run().then()
  // }, []);

  return <UserWalletWithdrawReportsComponent data={data} />;
}

export default UserWalletWithdrawReportsContainer;
